import { render } from "./bottomButtons.vue?vue&type=template&id=2b93e746&scoped=true"
import script from "./bottomButtons.vue?vue&type=script&lang=js"
export * from "./bottomButtons.vue?vue&type=script&lang=js"

import "./bottomButtons.vue?vue&type=style&index=0&id=2b93e746&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b93e746"]])

export default __exports__